<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import { ResponsiveVars, TwistBox } from '@twist/core';
  import { jobsFiltersStore } from '$lib/stores/Careers/jobFiltersStore';
  import { toFluidVarInput } from '$lib/utils/fluidity';

  const dispatch = createEventDispatcher();

  function handleResetFilters() {
    jobsFiltersStore.reset();

    dispatch('filters-change', $jobsFiltersStore);
  }

  const responsiveVars = new ResponsiveVars()
    .addFluid('button-px', toFluidVarInput(9, 9))
    .addFluid('button-py', toFluidVarInput(6, 6))
    .addFluid('button-font-size', toFluidVarInput(15, 15))
    .toCSS();
</script>

<TwistBox marginTop={toFluidVarInput(45, 0)} marginBottom={toFluidVarInput(30, 0)}>
  <button class={responsiveVars} on:click={handleResetFilters}>Reset filters</button>
</TwistBox>

<style>
  button {
    border: none;
    outline: none;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    font-family: var(--font-family-primary);
    font-size: var(--button-font-size);
    line-height: 120%;

    font-weight: 600;
    background: none;
    cursor: pointer;
    text-decoration: underline;
    padding: var(--button-py) var(--button-px);
    margin-right: calc(-1 * var(--button-px));

    &:hover,
    &:focus-visible {
      text-decoration: none;
      background: white;
      border-radius: 1000px;
    }

    &:active {
      opacity: 0.6;
    }
  }
</style>
